// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"aed844d5","117":"6b976a21","161":"211d958b","191":"43abe075","209":"04592873","478":"1099814f","625":"a9af9006","773":"d56afb2f","922":"950c5cf1","964":"573e055a"}[chunkId] + ".chunk.js";
};